import React, { useState, useEffect } from 'react';
import { DateField } from '@gerdau/hefesto-mais-web/DateField';
import { DateType } from '@gerdau/hefesto-mais-web/DateField/DateField.types';
import { Container } from './styles';
import { Tooltip } from 'antd';
import moment from 'moment';
import theme from '../../../assets/styles/theme/theme';
import {
  isOutOfMinimunDate,
  isWeekend
} from '../../../pages/Purchase/LongSteel/OrderSettings/ShoppingCartTable/shoppingCartFieldsValidation';
interface DateInputProps {
  value?: string;
  minimumDate: string;
  onSelectDate(date: string): void;
  label?: string;
  width?: string;
  disabled?: boolean;
  readOnly?: boolean;
}

const DateInput: React.FC<DateInputProps> = ({
  value,
  minimumDate,
  onSelectDate,
  label,
  width,
  disabled,
  readOnly
}) => {
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const updateErrorMessage = () => {
      setErrorMessage('');

      if (isOutOfMinimunDate(minimumDate, value)) {
        setErrorMessage(
          `A data mínima é ${moment(minimumDate, 'YYYY-MM-DD').format(
            'DD/MM/YYYY'
          )}`
        );
      } else if (isWeekend(moment(value, 'YYYY-MM-DD'))) {
        setErrorMessage(`A data desejada não pode ser no sábado ou domingo.`);
      }
    };
    updateErrorMessage();
  });

  return (
    <Tooltip
      overlayClassName="shop-cart-input-tooltip"
      placement="top"
      title={errorMessage !== '' ? errorMessage : ''}
      trigger={['hover', 'click']}
      color={theme.colors.red}
    >
      <Container error={errorMessage !== '' ? true : false} width={width}>
        <DateField
          name="dateField"
          label={label ?? ''}
          variant={errorMessage ? 'danger' : undefined}
          disableWeekend
          selected={value ? moment(value, 'YYYY-MM-DD').toDate() : undefined}
          data-testid="dateField"
          minDate={moment(minimumDate, 'YYYY-MM-DD').toDate()}
          onChange={(date: DateType) => {
            if (date) {
              onSelectDate(moment(date as Date).format('YYYY-MM-DD'));
            }
          }}
          disabled={disabled ?? false}
          readOnly={readOnly ?? false}
        />
      </Container>
    </Tooltip>
  );
};

export default DateInput;
